import { Routes } from '@angular/router';
import { RecuperarComponent } from './recuperar.component';

/** Ruta pública de recuperación de contraseña ("olvidé mi clave", sin guard de autenticación). */
export const RECUPERAR_ROUTES: Routes = [
  {
    path: '',
    component: RecuperarComponent,
  },
];
